export enum ThirdParty {
    TINK = 'TINK',
    UNAX = 'UNAX'
}